module.exports = __webpack_public_path__ + "img/about-business.1f3319f.png";